import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-total-earnings',
  templateUrl: './total-earnings.component.html',
  styleUrls: ['./total-earnings.component.css']
})
export class TotalEarningsComponent implements OnInit {

  @Input() TotalEarnings: number;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/components/total-earnings/total-earnings.component.ts